var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"totip"},[_vm._v("为保证检测准确性，建议上传")])
}
var staticRenderFns = []

export { render, staticRenderFns }